<template>
<div class=" flex">
  <img v-if="movie && movie.length !=0" :src="movie.response.poster" alt="">
  <vs-upload v-if="movie && movie.response" :action="`${this.$apiUrl}/movies/poster/${movie.response.id}`" fileName="poster"  limit="1" text="Poster Image" vs-tab="dfdf" :automatic="true" @on-success="successUpload" />
</div>

</template>

<script>
export default {
    props:['movie'],
  methods:{
    successUpload(){
      this.$vs.notify({color:'success',title:'Upload Success',text:''})
      location.reload();
    }
  }
}
</script>